/**
 * HarvestInspectionsExportButton
 */
import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';

// Components
import HarvestInspectionsExportAllDropdownItem from './components/HarvestInspectionsExportAllDropdownItem';
import HarvestInspectionsExportAllMergedDropdownItem from './components/HarvestInspectionsExportAllMergedDropdownItem';

// Selectors
import { makeSelectLoading } from '../../../../../../services/loading/selectors';

interface Props {
    requestExportReportsHarvestInspectionsAll: Function;
    requestExportReportsHarvestInspectionsAllMerged: Function;
    loading: boolean;
}

export class HarvestInspectionsExportButton extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.requestExportReportsHarvestInspectionsAllMerged();
    };

    render() {
        const { loading } = this.props;
        return (
            <Dropdown
                direction="left"
                floating
                button
                className="secondary float circular small"
                text="Export"
                selectOnBlur={false}
                loading={loading}
                style={{
                    minWidth: 99
                }}
            >
                <Dropdown.Menu>
                    <HarvestInspectionsExportAllDropdownItem />
                    <HarvestInspectionsExportAllMergedDropdownItem />
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    loading: makeSelectLoading([
        'REPORTS_HARVEST_INSPECTIONS_ALL_EXPORT',
        'REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT'
    ])
});

export default connect(mapStateToProps)(HarvestInspectionsExportButton);
